
export const FILTER_GLOW_SUBTLE_ID = 'filter--glow-subtle';

const OPACITY = 0.75;

export const FilterGlowSubtle: React.FC = () => (
  <filter id={FILTER_GLOW_SUBTLE_ID} y="-40%" height="180%" x="-40%" width="180%">
    <feGaussianBlur result="BLURRED" stdDeviation="24" />
    <feComponentTransfer>
      <feFuncA type="linear" slope={OPACITY} />
    </feComponentTransfer>
    <feMerge>
      <feMergeNode />
      <feMergeNode in="SourceGraphic" />
    </feMerge>
  </filter>
);
